// extracted by mini-css-extract-plugin
export default {"video-banner":"VideoBanner_video-banner__jMF69"};